import { createSelector } from 'reselect';

export const getSourcesLoaded = (state) => state.sources.siteLoaded;

export const getSourcesUpdatedAt = (state) => state.sources.sourcesUpdatedAt;

export const getSources = (state) => state.sources.sources;

export const getSourceTypes = (state) => state.sources.sourceTypes;

export const getInjectableSourceTypes = (state) => state.sources.injectableSourceTypes;

export const getImportableSourceTypes = (state) => state.sources.importableSourceTypes;

export const getSyncedSources = (state) => state.sources.syncedSourceTypes;

export const getSyncHealth = (state, siteId) => state.sources.syncHealth[siteId];

export const getSiteVariablesIndex = (state) => state.sources.siteVariablesIndex;

export const getSiteVariables = createSelector([getSiteVariablesIndex], (variableIndex = {}) =>
  Object.values(variableIndex)
);

export const getSiteVariablesUpdatedAt = (state) => state.sources.siteVariablesUpdatedAt;

export const getSourceConnectivityTree = (state) => state.sources.sourceConnectivityTree;

export const getAggregatedConnectivity = (state) => state.sources.aggregatedConnectivity;

export const getVariableById = createSelector(
  [(_, variableId) => variableId, getSiteVariablesIndex],
  (variableId, variableIndex = {}) => variableIndex[variableId]
);

export const getLinkedSources = createSelector(getSources, (sources) =>
  sources.filter((s) => s.options?.siteSourceLink)
);
